import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import TableActions from "./table-actions";
import { Box } from "@mui/material";
import { IUserAccount } from "src/types/clients";
import { useRecoilState } from "recoil";
import { authState } from "src/store/auth";

const tableHeadText = ["Name", "Email"];

interface IProps {
  userAccounts: IUserAccount[];
  refetch: Function;
  clientId: string;
}

const AccountUsers = (props: IProps) => {
  const { userAccounts, refetch, clientId } = props;

  const [auth] = useRecoilState(authState);

  const noData = userAccounts.length === 0;

  return (
    <Box>
      <Box
        sx={{
          bgcolor: "#1A1A1A",
          boxShadow: "0px 14px 44px 0px rgba(0, 0, 0, 0.35)",
          padding: "30px",
        }}
      >
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {tableHeadText.map((item) => (
                  <TableCell
                    key={item}
                    sx={{
                      fontWeight: 600,
                      color: "#A1A5B7",
                    }}
                    align={item === "Actions" ? "right" : "left"}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {false ? (
              <TableLoadingSkeleton rowsLength={2} cellsLength={2} />
            ) : (
              <TableBody>
                {userAccounts.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.email}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
          {noData && <NoData subtitle="" />}
        </TableContainer>
      </Box>
    </Box>
  );
};
export default AccountUsers;
